import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class UrlService {
  private previousUrl: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public previousUrl$: Observable<string> = this.previousUrl.asObservable();
    private _previousUrl: string;
    private _urlList = [];

  constructor() { }

  setCurrentUrl(url: string) {


    if(this._urlList.length == 0)
    {
        this._urlList.push(url);
    }
    else{
        if(this._urlList[this._urlList.length-1] != url)
        {
            
                this._urlList.push(url);
         
        }
    }

    //this.previousUrl.next(previousUrl);
  }

  setBack()
  {
    if(this._urlList.length >0)
    {
        this._urlList.pop();
    }
    
  }

  getPreviousUrl()
  {
    if(this._urlList.length > 1)
    {
       return  this._urlList[this._urlList.length-2];
    }
    else{
        return "";
    }
  }
}